import Vue from 'vue';
import Vuex, { Plugin } from 'vuex';
import createPersistedState from 'vuex-persistedstate';

import globals from './modules/globals';
import user from './modules/user';
import studio from './modules/studio';
import event from './modules/event';
import product from './modules/product';
import quiz from './modules/quiz';
import dashboard from './modules/dashboard';
import sale from './modules/sale';
import mediaLibrary from './modules/media-library';
import dataImport from './modules/data-import';
import report from './modules/report';
import setting from './modules/setting';
import studentSolvedQuiz from './modules/student-solved-quiz';
import websocket from './modules/websocket';
import affiliates from './modules/affiliates';
import community from './modules/community';
import storage from '@/core/store/storage';
import headers from './modules/headers';
import filters from './modules/filters';
import page from './modules/page';
import marketing from './modules/marketing';
import contracts from './modules/contracts';
import podcasts from './modules/podcasts';

const plugins: Plugin<any>[] = [
  createPersistedState({
    paths: [
      'user.accessToken',
      'user.localStudioPassword',
      'setting.streamingProps',
      'community.interactAsStudio',
      'setting.useCustomDomainUrl',
      'globals.showInstallPWA',
      'globals.isPWA',
      'globals.showCookieNotice',
    ],
    storage,
  }),
];

Vue.use(Vuex);

// @ts-ignore
export default new Vuex.Store({
  modules: {
    globals,
    user,
    studio,
    event,
    product,
    quiz,
    dashboard,
    sale,
    mediaLibrary,
    dataImport,
    report,
    setting,
    studentSolvedQuiz,
    websocket,
    community,
    affiliates,
    headers,
    filters,
    page,
    marketing,
    contracts,
    podcasts,
  },
  plugins: plugins,
});
